var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteImgModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6667 30.2222C42.6667 28.7495 43.8606 27.5556 45.3334 27.5556H49.7778C51.2506 27.5556 52.4445 28.7495 52.4445 30.2222V30.6667H42.6667V30.2222ZM39.1111 30.6667V30.2222C39.1111 26.7858 41.8969 24 45.3334 24H49.7778C53.2143 24 56 26.7858 56 30.2222V30.6667H63.109H63.1102H65.3334C66.3152 30.6667 67.1112 31.4626 67.1112 32.4445C67.1112 33.4263 66.3152 34.2222 65.3334 34.2222H64.7875L62.9098 66.1433C62.7163 69.4321 59.9928 72.0001 56.6983 72.0001H38.413C35.1185 72.0001 32.3949 69.4321 32.2015 66.1433L30.3238 34.2222H29.7778C28.7959 34.2222 28 33.4263 28 32.4445C28 31.4626 28.7959 30.6667 29.7778 30.6667H32.0011H32.0023H39.1111ZM35.7509 65.9345L33.8855 34.2222H61.2258L59.3604 65.9345C59.2775 67.344 58.1102 68.4446 56.6983 68.4446H38.413C37.001 68.4446 35.8338 67.344 35.7509 65.9345ZM44.8889 41.3334C44.8889 40.3515 44.093 39.5556 43.1111 39.5556C42.1293 39.5556 41.3334 40.3515 41.3334 41.3334V61.3334C41.3334 62.3152 42.1293 63.1112 43.1111 63.1112C44.093 63.1112 44.8889 62.3152 44.8889 61.3334V41.3334ZM52 39.5556C52.9819 39.5556 53.7778 40.3515 53.7778 41.3334V61.3334C53.7778 62.3152 52.9819 63.1112 52 63.1112C51.0182 63.1112 50.2223 62.3152 50.2223 61.3334V41.3334C50.2223 40.3515 51.0182 39.5556 52 39.5556Z",
    fill: "#FF5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImgModal);
export default __webpack_public_path__ + "static/media/delete-img-modal.9ad0d6af0c43c299c54da44d60cb9fd9.svg";
export { ForwardRef as ReactComponent };